import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './role-properties-skeleton.scss';

const RolePropertiesSkeleton = () => (
  <div className="role-properties-skeleton">
    <div className="role-properties-skeleton-field">
      <Skeleton variant="text" width="8rem" />
      <Skeleton variant="rect" width="100%" height="3.6rem" />
    </div>

    <div className="role-properties-skeleton-field">
      <Skeleton variant="text" width="6rem" />
      <Skeleton variant="rect" width="100%" height="3.6rem" />
    </div>
  </div>
);

export default RolePropertiesSkeleton;
